import React, { Component } from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/fontawesome-free-solid";
// import { Link } from "react-router-dom";

class AdminFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      approveall: false,
      submitApproveAll: false
    }
    this.handleApproveAll        = this.handleApproveAll.bind(this);
    this.handleCancelApproveAll  = this.handleCancelApproveAll.bind(this);
    this.submitApprovedAll       = this.submitApprovedAll.bind(this);
  }

  handleApproveAll(e) {
    this.setState({ approveall: true })
  }

  handleCancelApproveAll(e) {
    this.setState({ approveall: false })
  }

  submitApprovedAll(e) {
    this.setState({ submitApproveAll: true })
    this.setState({ approveall: false })
    this.props.approvedEntries();
  }

  render() {
    return (
      <div className="col s12 l2 m2 valign-wrapper push-l10 push-m10" id="footer">
          <div className={`col s12 m12 l12 share-picture-wrapper ${this.state.approveall ? 'hide' : ''} `} onClick={this.handleApproveAll}>
              <span>Approve All</span>
              <div id="footer_photo_icon_wrapper">
                <FontAwesomeIcon icon={faCheck} size="2x" className="icon" />
              </div>
          </div>
          <div className={`col s12 m12 l12 share-picture-wrapper ${this.state.approveall ? '' : 'hide'} `}>
            <div className="n-dialogbox-admin">
              <div className="n-question">Are you sure you want to approve all photos?</div>
              <div>
                <div className="n-ans yes" onClick={this.submitApprovedAll}>
                  <FontAwesomeIcon icon={faCheck} /> Yes  
                </div>
                <div className="n-ans" onClick={this.handleCancelApproveAll}>
                  <FontAwesomeIcon icon={faTimes} /> No
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }
};
export default AdminFooter;



// WEBPACK FOOTER //
// ./src/components/AdminFooter.js